import { Result, ok, err } from '@xlearn/common';

export enum SuccessStatus {
  unknown,
  passed,
  failed
}

export function statusToString(value: SuccessStatus): string {
  switch (value) {
    case SuccessStatus.unknown:
      return 'unknown';
    case SuccessStatus.passed:
      return 'passed';
    case SuccessStatus.failed:
      return 'failed';
  }
}

export function parseStatus(value: string): Result<SuccessStatus, false> {
  switch (value) {
  case 'passed':
      return ok(SuccessStatus.passed);
  case 'failed':
      return ok(SuccessStatus.failed);
    case 'unknown':
      return ok(SuccessStatus.unknown);
  default:
      return err(false);
  }
}
